import { useEffect, useState } from 'react';

const MOBILE_MAX_WIDTH = 768; // mirrors the Angular `isMobile` factory ($screen-sm-min)

// Returns true while the viewport is narrower than the mobile breakpoint, updating on resize.
// Mirrors the old isMobileMixin behavior that drove the account page's change-password layout.
export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < MOBILE_MAX_WIDTH);

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < MOBILE_MAX_WIDTH);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    return isMobile;
}
